import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { FormControl } from '@angular/forms'

@Component({
  selector: 'app-search-bar',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBarComponent implements OnChanges {
  searchField = new FormControl('')

  @Input() searchTerm: string
  @Input() set onNavigation(url: string) {
    if(!/search\/(.*)/.test(url))
       this.searchField.setValue('')
  }

  @Output() onSearch = new EventEmitter<string>()

  ngOnChanges(changes: SimpleChanges): void {
    const searchTermChange: SimpleChange = changes.searchTerm
    if (searchTermChange && !searchTermChange.firstChange) {
      this.searchField.setValue(searchTermChange.currentValue)
    }
  }

  keypress(event) {
    if((event.charCode || event.keyCode) === 13 && this.searchField.value)
      this.doSearch()
  }

  doSearch() {
    if (this.searchField.value) {
      this.onSearch.emit(this.searchField.value)
    }
  }
}
